module.exports = __webpack_public_path__ + "static/scale-model-of-john-brown-house-museum-in-providence-rhode-island-8ca44947caa4ac0c0c0c70185cade958.png";